import { useCallback } from "react";
import { useTrackedSessionStorage } from "./use-tracked-browser-storage";

const INCLUDE_BIDS_STORAGE_KEY = "salespeople::explorer::include-bids";

export function useIncludeBids() {
  const [includeBids, setIncludeBids] = useTrackedSessionStorage<boolean>(
    INCLUDE_BIDS_STORAGE_KEY,
    false,
  );

  const toggleIncludeBids = useCallback(() => {
    setIncludeBids((prev) => !prev);
  }, [setIncludeBids]);

  return {
    includeBids,
    toggleIncludeBids,
    setIncludeBids,
  };
}
